'use client';

import { usePathname } from 'next/navigation';

import FlowHeader from '@/components/header/header';
import MarketingHeader from '@/components/marketing/header/header';
import { isFlowPathname } from '@/lib/form';

export default function RouteHeader() {
  const pathname = usePathname();

  return isFlowPathname(pathname) ? <FlowHeader /> : <MarketingHeader />;
}
